import Cookies from "js-cookie";

function joinParams(obj) {
  let templateArray = [];
  for (let key in obj) {
    if (obj[key] || obj[key] == 0) {
      if (obj[key].constructor == Array) {
        obj[key].forEach((one, index) => {
          templateArray.push(`${key}[${index}]=${one}`);
        });
      } else {
        templateArray.push(`${key}=${obj[key]}`);
      }
    }
  }
  let returnStr = templateArray.join("&");
  return `?${returnStr}`;
}

//公司成本表
export async function getFeeList(year) {
  return fetch(
    `https://www.guanglutongda.com/api/fee_type/feeList${joinParams({
      year: year || "",
    })}`,
    {
      headers: {
        Authorization: "Bearer " + Cookies.get("token"),
        version: "all",
      },
    }
  ).then((res) => res.json());
}

export async function feeList(year) {
  return fetch(`https://www.guanglutongda.com/api/fee_type`, {
    headers: {
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => res.json());
}

//添加每月的公司成本
export async function addFeeData(params) {
  return fetch(`https://www.guanglutongda.com/api/fee`, {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => res.json());
}

//添加成本分类
export async function addFeeType(params) {
  return fetch(`https://www.guanglutongda.com/api/fee_type`, {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => res.json());
}

//用户管理
export async function getUserList(params) {
  let { type } = params;
  return fetch(
    `https://www.guanglutongda.com/api/user/list${joinParams({
      ...params,
      regexp: true,
      type: type ? type : 1
    })}`,
    {
      headers: {
        Authorization: "Bearer " + Cookies.get("token"),
        version: "all",
      },
    }
  ).then((res) => res.json());
}

//用户管理
export async function getAllUsers() {
  return fetch(`https://www.guanglutongda.com/api/user/list`, {
    headers: {
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => res.json());
}

//利润与提成
export async function getOrderList(params) {
  let {
    page,
    size,
    name,
    veneer,
    telemarketingStaf,
    status,
    generalCarrier,
    waybill,
    startTime,
    endTime,
    timeSearch,
    isCalucateCommission,
    companyId,
    operationPersonnel,
    generalCarrierNumber
  } = params;
  return fetch(
    `https://www.guanglutongda.com/api/order/pcList${joinParams({
      page: page,
      size: size,
      regexp:true,
      "user.nickname": name,
      waybill: waybill || "",
      veneer: veneer,
      telemarketingStaf: telemarketingStaf,
      status: status,
      generalCarrier: generalCarrier,
      startTime: startTime || "",
      endTime: endTime || "",
      timeSearch: timeSearch || "",
      sort: "createdAt",
      order: "DESC",
      isCalucateCommission: isCalucateCommission || undefined,
      "company.id": companyId || undefined,
      operationPersonnel: operationPersonnel || undefined,
      generalCarrierNumber: generalCarrierNumber || undefined
    })}`,
    {
      headers: {
        Authorization: "Bearer " + Cookies.get("token"),
        version: "all",
      },
    }
  ).then((res) => res.json());
}

//新增或修改订单信息
export async function upsertOrder(params) {
  return fetch(`https://www.guanglutongda.com/api/order/pcSave`, {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => res.json());
}

//导出客户管理数据
export async function exportCustomerList(params) {
  return fetch(`https://www.guanglutongda.com/api/company/pcExport`, {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => {
    return res.blob();
  });
}

//导出订单信息
export async function exportOrderList(params) {
  return fetch(`https://www.guanglutongda.com/api/order/pcExport`, {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => {
    return res.blob();
  });
}

//保存首页数据信息
export async function upsertStatistic(params) {
  return fetch(`https://www.guanglutongda.com/api/statistic`, {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => res.json());
}

//首页获取当月数据
export async function getCurrentHonthList() {
  return fetch(`https://www.guanglutongda.com/api/statistic/currentMonthList`, {
    headers: {
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => res.json());
}

//首页，获取当天的数据
export async function getStatisticList(params) {
  return fetch(`https://www.guanglutongda.com/api/statistic/list${joinParams(params)}`, {
    headers: {
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => res.json());
}

//新首页查询接口
export async function getNewHomeIndexList(params) {
  let { startTime, endTime } = params;
  return fetch(
    `https://www.guanglutongda.com/api/order/statistic${joinParams({
      startTime: startTime,
      endTime: endTime,
    })}`,
    {
      headers: {
        Authorization: "Bearer " + Cookies.get("token"),
        version: "all",
      },
    }
  ).then((res) => res.json());
}

//公司企业下拉框
export async function getCompanyDropdown() {
  return fetch(`https://www.guanglutongda.com/api/company/list`, {
    headers: {
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => res.json());
}

//查询公司企业数据
export async function getCompanyList(params) {
  let {
    page,
    size,
    id,
    companyPerson,
    shippingAmount,
    phone,
    clientLevel,
    telemarketing,
    businessManager,
    facePin,
  } = params;
  return fetch(
    `https://www.guanglutongda.com/api/company/list${joinParams({
      page: page,
      size: size,
      id: id,
      companyPerson: companyPerson,
      phone: phone,
      shippingAmount: shippingAmount,
      clientLevel: clientLevel,
      telemarketing: telemarketing,
      businessManager: businessManager,
      facePin: facePin,
    })}`,
    {
      headers: {
        Authorization: "Bearer " + Cookies.get("token"),
        version: "all",
      },
    }
  ).then((res) => res.json());
}

//保存或编辑企业数据信息
export async function upsertCompany(params) {
  return fetch(`https://www.guanglutongda.com/api/company`, {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => res.json());
}

//删除企业数据信息
export async function deleteCompany(params) {
  return fetch(`https://www.guanglutongda.com/api/company`, {
    method: "Delete",
    body: JSON.stringify(params),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => res.json());
}

//删除运单（订单）数据信息
export async function deleteOrder(params) {
  return fetch(`https://www.guanglutongda.com/api/order`, {
    method: "Delete",
    body: JSON.stringify(params),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => res.json());
}

//用户管理的详情
export async function getUsersByCompany(id, phone, realname) {
  return fetch(
    `https://www.guanglutongda.com/api/user/list${joinParams({
      type: 1,
      "company.id": id,
      phone: phone || "",
      realname: realname || "",
    })}`,
    {
      headers: {
        Authorization: "Bearer " + Cookies.get("token"),
        version: "all",
      },
    }
  ).then((res) => res.json());
}

//客户名称下拉框
export async function getUserListByType() {
  return fetch(
    `https://www.guanglutongda.com/api/user/list${joinParams({
      type: 1,
    })}`,
    {
      headers: {
        Authorization: "Bearer " + Cookies.get("token"),
        version: "all",
      },
    }
  ).then((res) => res.json());
}

//寄件人地址
export async function getSendAddress() {
  return fetch(`https://www.guanglutongda.com/api/address_viable/list`, {
    headers: {
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => res.json());
}

//获取全国地址级联信息
export async function getAddressList() {
  return fetch(`https://www.guanglutongda.com/api/address/three/level`, {
    headers: {
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => res.json());
}

//用户的新增修改
export async function upsertUser(params) {
  return fetch(`https://www.guanglutongda.com/api/user/pc`, {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => res.json());
}

//删除用户信息
export async function deleteUser(params) {
  return fetch(`https://www.guanglutongda.com/api/user`, {
    method: "Delete",
    body: JSON.stringify(params),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => res.json());
}

//获取基础运费价格
export async function getEstimatedPrice(params) {
  let {
    province,
    city,
    district,
    weight,
    volume,
    sendProvince,
    sendCity,
    sendDistrict,
  } = params;
  return fetch(
    `https://www.guanglutongda.com/api/address/estimated/price${joinParams({
      province: province,
      city: city,
      district: district,
      weight: weight,
      volume: volume,
      sendProvince: sendProvince,
      sendCity: sendCity,
      sendDistrict: sendDistrict,
    })}`,
    {
      headers: {
        Authorization: "Bearer " + Cookies.get("token"),
        version: "all",
      },
    }
  ).then((res) => res.json());
}

//获取CRM数据
export async function getCRMList(params) {
  let {
    page,
    size,
    companyName,
    companyPerson,
    companyPhone,
    salesman,
    startTime,
    endTime,
    timeSearch,
    isInvite,
  } = params;
  return fetch(
    `https://www.guanglutongda.com/api/crm/list${joinParams({
      page: page,
      size: size,
      companyName: companyName,
      companyPerson: companyPerson,
      companyPhone: companyPhone,
      salesman: salesman,
      isInvite: isInvite,
      startTime: startTime || "",
      endTime: endTime || "",
      timeSearch: timeSearch || "",
    })}`,
    {
      headers: {
        Authorization: "Bearer " + Cookies.get("token"),
        version: "all",
      },
    }
  ).then((res) => res.json());
}

//获取CRM数据
export async function getCRMData(params) {
  let { page, size, salesman, dataTime } = params;
  return fetch(
    `https://www.guanglutongda.com/api/crm/statistic${joinParams({
      page: page,
      size: size,
      salesman: salesman,
      dataTime: dataTime,
    })}`,
    {
      headers: {
        Authorization: "Bearer " + Cookies.get("token"),
        version: "all",
      },
    }
  ).then((res) => res.json());
}

//新增或修改CRM数据
export async function upsertCRM(params) {
  return fetch(`https://www.guanglutongda.com/api/crm`, {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => res.json());
}

//删除CRM信息
export async function deleteCRM(params) {
  return fetch(`https://www.guanglutongda.com/api/crm`, {
    method: "Delete",
    body: JSON.stringify(params),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => res.json());
}

//导出CRM详情数据
export async function exportCRMList(params) {
  return fetch(`https://www.guanglutongda.com/api/crm/list/export`, {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => {
    return res.blob();
  });
}

//导出CRM统计数据
export async function exportCRMSumList(params) {
  return fetch(`https://www.guanglutongda.com/api/crm/statistic/export`, {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + Cookies.get("token"),
      version: "all",
    },
  }).then((res) => {
    return res.blob();
  });
}
